module.exports = __webpack_public_path__ + "static/media/logo-full(ua).d74876e4.svg";